module.exports = __webpack_public_path__ + "static/img/vampire_fleder.e2456e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/vampire_fleder.png
// module id = bS6k
// module chunks = 0